import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {CardBrandType} from '../../constants'
import {PURCHASE_STATE_RESET} from '../purchaseLightBox/actionTypes'

const initialState = {
    cardBrand: CardBrandType.NONE,
    cardNumber: '',
    holderName: '',
    expiredMonth: '',
    expiredYear: '',
    address: '',
    city: '',
    zip: '',
    country: '',
    state: '',
    editable: false,
    isAddressFormOpen: false,
    cardToken: '',
    needToSaveCard: false,
    stripeFieldsValid: {
        cardNumber: false,
        cardExpiry: false,
        cardCvc: false,
    }
}

export default handleActions({
    [PURCHASE_STATE_RESET]: () => ({
        ...initialState
    }),
    [ActionTypes.NEED_SAVE_CARD_SET]: (state) => ({
        ...state,
        needToSaveCard: !state.needToSaveCard,
    }),
    [ActionTypes.EDITABLE_SET]: (state, {payload: editable}) => ({
        ...state,
        editable,
    }),
    [ActionTypes.IS_ADDRESS_FORM_OPEN_SET]: (state, {payload: isAddressFormOpen}) => ({
        ...state,
        isAddressFormOpen,
    }),
    [ActionTypes.CARD_FIELDS_CHANGE]: (state, {payload: data}) => ({
        ...state,
        ...data,
    }),
    [ActionTypes.BILLING_ADDRESS_SET]: (state, {payload: data}) => ({
        ...state,
        address: data.address,
        city: data.city,
        zip: data.zip,
        country: data.country,
        state: data.state,
    }),
    [ActionTypes.CARD_INFO_SET]: (state, {payload: data}) => ({
        ...state,
        cardNumber: data.cardNumber,
        holderName: data.holderName,
        expiredMonth: data.expiredMonth,
        expiredYear: data.expiredYear,
        address: data.address,
        city: data.city,
        zip: data.zip,
        country: data.country,
        state: data.state,
        cardBrand: data.cardBrand,
    }),
    [ActionTypes.STRIPE_FIELDS_VALID_SET]: (state, {payload: data}) => ({
        ...state,
        stripeFieldsValid: {
            ...state.stripeFieldsValid,
            ...data,
        },
    }),
}, initialState)


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/creditCard/reducer.js